import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

faker.seed(1);

export default Factory.extend({
	id: () => faker.string.uuid(),
	creationDate: () => new Date().toISOString(),
	deviceModel: () => 'Samsung Galaxy S25',
	deviceOS: () => 'Android 16',
	appVersion: () => '4.0.' + String(faker.number.int({ min: 1, max: 17 })),
	loginStatus: () => faker.helpers.arrayElement(['OK', 'KO']),
	ipAddress: () => faker.internet.ip(),
	scaRequired: () => faker.datatype.boolean(),
	assistedChannelsSession: () => faker.datatype.boolean(),
	manager: () => faker.person.fullName(),
});
